import { h, Fragment } from 'preact'
import { useState, useCallback, useEffect, useRef } from 'preact/hooks'
import axios from 'axios';
import Illustration from '../../images/dividend/ill-beach.svg';
import IllustrationMobile from '../../images/dividend/ill-beach-mobile.png';
import IllustrationMobile2x from '../../images/dividend/ill-beach-mobile@2x.png';
import IllustrationMobile3x from '../../images/dividend/ill-beach-mobile@3x.png';
import Illustration2 from '../../images/dividend/ill-bike.svg';
import Illustration2Mobile from '../../images/dividend/ill-bike-mobile.png';
import Illustration2Mobile2x from '../../images/dividend/ill-bike-mobile@2x.png';
import Illustration2Mobile3x from '../../images/dividend/ill-bike-mobile@3x.png';
import MapAnimation from '../../images/dividend/map_animation_2.gif';
import MapSuccess from '../../images/dividend/success.gif';
import SuccessLeft from '../../images/dividend/ill-success-left.svg';
import SuccessRight from '../../images/dividend/ill-success-right.svg';
import ChatbotIcon from '../../images/dividend/ic-gift-closed.svg';
import ChatbotOpenIcon from '../../images/dividend/ic-gift-open.svg';
import CouponImage from '../../images/dividend/ill-coupon.svg';
import LoadingIcon from '../../images/dividend/ic_loading.svg';
import CloseIcon from '../../images/dividend/ic-close.svg';
import Envelope from '../../images/dividend/ill-envelope.svg';
import Avatar1x from '../../images/dividend/img-ashley.png';
import Avatar2x from '../../images/dividend/img-ashley@2x.png';
import Avatar3x from '../../images/dividend/img-ashley@3x.png';
import { SwitchTransition, CSSTransition } from "@bmp/preact-transition-group";
import Utility from '../../classes/Utility';
const { BroadcastChannel: Channel } = require('broadcast-channel')

const urlParams = new URLSearchParams(window.location.search);
const forceShow = urlParams.get('annuityemail') == 'true';
const sessionKeyPrefix = forceShow ? 'forceshow_' : 'v2_';
const SessionChannel = new Channel(`${sessionKeyPrefix}annuity_session`, {webWorkerSupport: false});
SessionChannel.onmessage = (event) => {
  const { type, data, origin } = event
  if (origin == location.origin) {
    if (type == 'newSession') {
      const sessionStorageArray = Object.keys(sessionStorage).map(k => (
        { [k]: sessionStorage.getItem(k) }
      ))
      const message = {
        type: 'restoreSession',
        data: sessionStorageArray,
        origin: location.origin
      }
      SessionChannel.postMessage(message);
    } else if (type == 'restoreSession') {
      // receives event for new session to populate
      if (sessionStorage.length < data.length) {
        data.forEach(sessionData => {
          const key = Object.keys(sessionData)[0];
          sessionStorage.setItem(key, sessionData[key]);
        })
      }
    } else if (type == 'updateSession') {
      const key = Object.keys(data)[0];
      sessionStorage.setItem(key, data[key]);
    }
  }
}
SessionChannel.postMessage({
  origin: window.location.origin,
  type: 'newSession'
});

const saveToSession = (key, data) => {
  const sessionKey = sessionKeyPrefix + key
  SessionChannel.postMessage({
    type: 'updateSession',
    data: { [sessionKey]: data },
    origin: location.origin
  })
  sessionStorage.setItem(sessionKey, data);
}

const getFromSession = (key) => {
  const sessionKey = sessionKeyPrefix + key
  return sessionStorage.getItem(sessionKey)
}

const color = {
  base: "orange-650",
  hover: "orange-675",
  withOpacity: "orange-6502"
}

const SpinningCircle = () => (
  <div
    style={{
      width: '20px',
      height: '20px',
      top: '1px'
    }}
    className='t-absolute t-right-0 t-mr-2 n-rotate animated fadeIn'
  >
    <img src={LoadingIcon} />
  </div>
)

const IllustrationBox = ({ currentStepData, totalSteps }) => {
  if (currentStepData.type != 'text' && currentStepData.type != 'coupon' && currentStepData.step_key != 'zip_code') {
    const currentIllustration = totalSteps > 3 ? {
      right: '45',
      bottom: '28',
      src: Illustration2,
      mobileSrc: Illustration2Mobile,
      mobileSrc2x: Illustration2Mobile2x,
      mobileSrc3x: Illustration2Mobile3x
    } : {
      right: '60',
      bottom: '47',
      src: Illustration,
      mobileSrc: IllustrationMobile,
      mobileSrc2x: IllustrationMobile2x,
      mobileSrc3x: IllustrationMobile3x,
    };
    return (
      <div className={`t-absolute fadeInUp animated t-right-0 t-bottom-0 md:t--right-${currentIllustration.right} md:t--bottom-${currentIllustration.bottom}`}>
        <img src={currentIllustration.src} className="t-hidden md:t-block t-float-right"/>
        <img
          src={currentIllustration.mobileSrc}
          className="md:t-hidden t-block t-float-right"
          srcSet={`${currentIllustration.mobileSrc2x} 2x,${currentIllustration.mobileSrc3x} 3x`}
        />
      </div>
    )
  }
}

const AdditionalNotes = ({ currentStepData, totalSteps, additionalNote }) => {
  const { showCollapse, toggleCollapse } = useCollapse();
  useEffect(() => {
    toggleCollapse(false);
  }, [currentStepData])

  if (totalSteps > 3 && currentStepData.type != 'text' && currentStepData.type != 'coupon' && currentStepData.step_key != 'zip_code') {
    return (
      <SwitchTransition mode="out-in">
        <CSSTransition
          key={showCollapse}
          addEndListener={(node, done) => {
            node.addEventListener("transitionend", done, false);
          }}
          classNames="n-fade-plain"
        >
          <div className="t-mt-8 t-ml-5 t-mr-5 xs:t-mt-12 xs:t-ml-auto xs:t-mr-auto t-inherit md:t-absolute md:t-pl-12 md:t-pr-12 t-text-center t-w-auto md:t-w-full t-z-10 t-max-w-md2 md:t-max-w-full" style={{bottom: '50px'}}>
            {
              totalSteps > 3 && (
                showCollapse ? (
                  <div className="t-p-5 md:t-pr-8 md:t-pl-8 t-bg-yellow-150">
                    <p className="t-text-base">
                      {additionalNote}
                    </p>
                      <p className={`t-text-${color.base} t-text-base t-font-bold t-mb-0`}>
                        <a href="#" onClick={e => {
                          e.preventDefault();
                          toggleCollapse(false);
                        }}>
                          Got it
                      </a>
                      </p>
                  </div>
                ) : (
                  <p className={`t-text-${color.base} t-text-base t-font-bold`}>
                    <a href="#" onClick={e => {
                      e.preventDefault();
                      toggleCollapse(true);
                    }}>
                        Why do we need this?
                    </a>
                  </p>
                )
              )
            }
          </div>
        </CSSTransition>
      </SwitchTransition>
    )
  }
  return null;
}

const SelectionButton = ({ fixedWidth, maxWidth, text, loading, selected, ...rest }) => {
  return (
    <button role="button" {...rest} className={`t-text-md t-text-white t-bg-${color.base} hover:t-bg-${color.hover} t-text-center t-p-3 t-pl-4 t-pr-4 t-rounded-full t-font-bold t-mt-1 t-mb-1 fast fadeInUp ${maxWidth && 'xs:t-max-w-xs t-ml-auto t-mr-auto t-mt-4'}`} style={{ minWidth: text == 'Yes' || text == 'No' ? '200px' : fixedWidth ? fixedWidth + 'px' : '280px', width: `min(${text == 'Yes' || text == 'No' ? '200' : '280'}px, 100%)`}} disabled={loading}>
      <div className="t-relative">
        <span>
          { text }
        </span>
        {
          (loading && selected) ? <SpinningCircle /> : <Fragment />
        }
      </div>
    </button>
  )
};

const InputBox = ({error, dropdown, value, children, ...rest}) => {
  return (
    <Fragment>
      <input {...rest} value={value} className={`t-w-full xs:t-w-90 t-h-12 t-text-md xs:t-text-lg t-rounded t-border t-p-3 t-mb-4 ${dropdown && 't-cursor-pointer'} ${error && 't-border-red-600'}`} readOnly={dropdown}>
      {
        dropdown && children
      }
      </input>
      {
        error && (
          <p className={`t-text-${color.base} t-text-base mt--1`}>
            { error }
          </p>
        )
      }
    </Fragment>
  )
}

const Container = ({children, complete, toggle, containerRef, ...rest}) => {
  let backdrop = {
    backdropFilter: 'blur(22px)',
    '-webkit-backdrop-filter': 'blur(22px)',
  };
  if (!CSS.supports('backdrop-filter', 'blur(22px)')) {
    backdrop = { backgroundColor: 'rgba(0,0,0,0.45)'}
  }
  const isDesktop = window.matchMedia('(min-width: 768px)');
  const maxHeight = isDesktop.matches ? (complete ? '660px' : '600px') : '';
  return (
    <Fragment>
      <div className="t-font-inter t-fixed t-z-2050 t-w-screen t-h-screen t-overflow-auto t-top-0 t-flex" style={{...backdrop, height: 'max(100vh, 100%)'}} {...rest}>
        <div ref={containerRef} className="md:t-mt-28 md:t-mb-28 md:t-rounded t-ml-auto t-mr-auto t-z-2000 t-bg-white t-shadow-md t-relative t-flex t-flex-col t-w-screen md:t-w-650p" style={{minHeight: '600px', maxHeight: maxHeight, borderCollapse: 'separate' }}>
          { children }
        </div>
      </div>
      <button onClick={() => toggle(false)} style={{ width: 30, height: 30 }} className="t-fixed t-bg-transparent t-rounded-full t-text-white t-z-2050 t-top-2 t-right-2 t-mr-1 t-mt-1 md:t-top-4 md:t-right-4">
        <img src={CloseIcon} />
      </button>
    </Fragment>
  )
}

const finalNotes = [
  {
    heading: 'Onboarding phone call',
    description: 'A quick no-obligation phone call with our onboarding team to make sure they connect you to an annuity professional with the right expertise.'
  },
  {
    heading: 'Consult with a professional',
    description: 'Find an annuity that meets your goals. Again, no obligations.'
  },
  {
    heading: 'Get guaranteed income for life',
    description: 'Review your goals with a licensed annuity agent that we connect you with. If you qualify, and everything suits your preferences, they will start an annuity application that meets your unique needs.'
  },

]

const FinalStepNotes = () => {
  return (
    finalNotes.map((note, index) => (
      <div key={note} className="t-flex t-mb-3 t-items-start">
        <div
          className="t-mr-4 t-flex t-justify-center t-items-center"
          style={{
            minWidth: '30px',
            height: '30px',
            borderStyle: 'solid',
            borderWidth: '2px',
            borderColor: '#fc8d77',
            borderRadius: '50%'
          }}>
          <p className={`t-text-${color.base} t-font-bold t-mb-0`}>
            { index + 1}
          </p>
        </div>
        <div className="t-flex t-flex-col">
          <p className="t-text-sm t-font-bold t-mb-2">
            { note.heading }
          </p>
          <p className="t-text-sm t-mb-2">
            { note.description }
          </p>
        </div>
      </div>
    ))
  )
}

const CouponStepNotes = ({ couponValue, couponCode, redirectUrl }) => {
  return (
    <Fragment>
      <p className={`t-text-${color.base} t-font-bold t-uppercase t-text-base xs:t-text-xl t-mt-6 t-mb-2`}>
        BUT
      </p>
      <Header noMargin>
        We&apos;d like to offer you <span className="t-font-bold">${couponValue}</span> off the first year of Dividend.com Premium to thank you for your time.
      </Header>
      <div className="t-mt-8 t-mb-6 t-h-auto" style={{width: 'min(100%, 505px)'}}>
        <img src={CouponImage} />
      </div>
      <SelectionButton text="Get the discount" onClick={e => {
        e.preventDefault();
        window.location.href = redirectUrl;
      }} />
      <p className={`t-text-sm t-mt-4 t-text-center`}>
        *use the discount code <span className="t-font-bold t-rounded t-p-1 t-bg-yellow-150">{couponCode}</span> at checkout
      </p>
    </Fragment>
  )
}

const ProgressBar = ({ currentStep, totalSteps}) => {
  let width = `${(currentStep + 1) / totalSteps * 100}%`;
  if (currentStep == 0) {
    width = '20px';
  }
  if (currentStep + 1 == totalSteps) {
    width = "calc(100% - 20px)";
  }
  return (
    <div className={`md:t-rounded-t t-w-full t-h-1 t-bg-${color.withOpacity} animated fadeInUp`}>
      <div className={`md:t-rounded-tl t-h-full t-transition-all t-will-change-width t-transition-linear t-bg-${color.base}`} style={{ width: width }} />
    </div>
  )
}

const Header = ({ inverted = false, noMargin = false, mobileLeftAlign, children, text }) => {
  return (
    <SwitchTransition mode="out-in">
      <CSSTransition
        key={text + !!children}
        addEndListener={(node, done) => {
          node.addEventListener("transitionend", done, false);
        }}
        classNames="n-fade"
      >
        <div className={`t-w-full ${mobileLeftAlign ? 't-text-left' : 't-text-center'} xs:t-text-center ${inverted || noMargin ? '' : 't-mt-12'} t-mb-0 animated`} style={{visibility: text == ' ' ? 'hidden': 'visible'}}>
          <p className={`t-text-${inverted ? 'white' : 'black'} t-text-base xs:t-text-md t-font-medium t-mb-0`}>
            { text ? (text == ' ' ? '/' : text) : children }
          </p>
        </div>
      </CSSTransition>
    </SwitchTransition>
  )
}

const Question = ({ inverted = false, mobileLeftAlign, reduceMargin, noPadding, text }) => {
  return (
    <SwitchTransition mode="out-in">
      <CSSTransition
        key={text}
        addEndListener={(node, done) => {
          node.addEventListener("transitionend", done, false);
        }}
        classNames="n-fade"
      >
        <div className={`t-w-full ${reduceMargin ? 't-mb-2' : 't-mb-8'} ${mobileLeftAlign ? 't-text-left t-mb-2' : 't-text-center'} xs:t-text-center ${!noPadding ? 't-pt-2' : ''}`}>
          <p className={`t-text-${inverted ? 'white' : 'black'} t-text-lg xs:t-text-2xl t-font-bold t-mb-0`}>
            { text }
          </p>
        </div>
      </CSSTransition>
    </SwitchTransition>
  )
}

const useModal = () => {
  const [show, setShow] = useState(false);
  const toggle = useCallback((assignedState = null) => {
    if (assignedState != null) {
      setShow(assignedState);
    } else {
      setShow(prevShow => !prevShow)
    }
  }, [show]);

  return {
    show, toggle
  }
}

const useDropdown = (containerRef) => {
  const [showDropdown, setDropdown] = useState(false);
  const toggleDropdown = useCallback((assignedState = null) => {
    if (assignedState != null) {
      setDropdown(assignedState)
    } else {
      setDropdown(prevShow => !prevShow)
    }
  }, [showDropdown])
  const [dropdownData, setDropdownData] = useState(null);
  const dropdownRef = useRef(null)

  useEffect(() => {
    if (containerRef.current) {
      const handleClickAway = e => {
        const { target } = e;
        if (dropdownRef.current && !dropdownRef.current.contains(target)) {
          toggleDropdown(false);
        }
      };
      containerRef.current.addEventListener('click', handleClickAway);
      return () => {
        containerRef.current.removeEventListener('click', handleClickAway);
      }
    }
  }, [showDropdown])

  return {
    showDropdown,
    toggleDropdown,
    dropdownData,
    setDropdownData,
    dropdownRef
  }
}

const renderBody = (currentStepData, loading, error, currentData, updateData, toggle, containerRef) => {
  const {
    showDropdown,
    toggleDropdown,
    dropdownData,
    setDropdownData,
    dropdownRef
  } = useDropdown(containerRef);
  switch (currentStepData.type) {
    case 'dropdown':
      return (
        <Fragment>
          <div style={{ maxWidth: '360px', margin: '0 auto'}}>
            <Header text={currentStepData.title || " "} />
          </div>
          <Question text={currentStepData.question || " "} />
          <SwitchTransition mode="out-in">
            <CSSTransition
              key={currentStepData.data}
              addEndListener={(node, done) => {
                node.addEventListener("transitionend", done, false);
              }}
              classNames="n-fade"
            >
              <div className="t-flex t-flex-col t-m-auto" style={{ width: 'max-content' }}>
                {
                  currentStepData.data && (
                    <Fragment>
                      <div className="t-relative t-text-xl xs:t-text-2xl" ref={dropdownRef} >
                        <InputBox
                          dropdown
                          placeholder={currentStepData.data.placeholder}
                          value={dropdownData || currentData[currentStepData.step_key]}
                          error={error && error[currentStepData.step_key]}
                          onClick={e => {
                            e.preventDefault();
                            e.stopPropagation();
                            toggleDropdown();
                          }}
                        />
                        <span className="fa fa-caret-down t-absolute" style={{ top: '12px', right: '10px', pointerEvents: 'none' }} />
                        <SwitchTransition mode="out-in">
                          <CSSTransition
                            key={showDropdown}
                            addEndListener={(node, done) => {
                              node.addEventListener("transitionend", done, false);
                            }}
                            classNames="n-fade-plain"
                          >
                            {
                              showDropdown ? (
                                <div className="t-absolute t-w-full t-shadow-strong t-border t-border-gray-750 t-top-0 t-left-0 t-bg-white t-flex t-flex-col t-z-11">
                                  {
                                    currentStepData.data.options.map(option => (
                                      <button key={option} className="t-bg-white t-bg-white hover:t-bg-gray-150 t-text-left" role="button" onClick={e => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        setDropdownData(option);
                                        updateData({ [currentStepData.step_key]: option })
                                        toggleDropdown();
                                      }}>
                                        <p className="t-text-gray-600 t-m-2 t-text-lg">
                                          {option}
                                        </p>
                                      </button>
                                    ))
                                  }
                                </div>
                              ) : <Fragment />
                            }
                          </CSSTransition>
                        </SwitchTransition>
                      </div>
                      <SelectionButton maxWidth loading={loading} selected type="submit" text="Next" />
                    </Fragment>
                  )
                }
              </div>
            </CSSTransition>
          </SwitchTransition>
        </Fragment>
      )
    case 'selection':
      return (
        <Fragment>
          <div style={{ maxWidth: '360px', margin: '0 auto'}}>
            <Header text={currentStepData.title || " "} />
          </div>
          <Question text={currentStepData.question || " "} />
          <SwitchTransition mode="out-in">
            <CSSTransition
              key={currentStepData.data}
              addEndListener={(node, done) => {
                node.addEventListener("transitionend", done, false);
              }}
              classNames="n-fade"
            >
              <div className="t-flex t-flex-col t-m-auto" style={{ width: 'max-content' }}>
                {
                  currentStepData.data && currentStepData.data.map(option => (
                    <SelectionButton loading={loading} selected={currentData[currentStepData.step_key] == option} key={option} type="submit" text={option} onClick={() => updateData({ [currentStepData.step_key]: option })} />
                  ))
                }
              </div>
            </CSSTransition>
          </SwitchTransition>
        </Fragment>
      );
    case 'input':
      return (
        <Fragment>
          { currentStepData.title !== '' ? <div style={{ maxWidth: '360px', margin: '0 auto'}}>
              <Header text={currentStepData.title || " "} />
            </div> : null
          }
          <Question text={currentStepData.question || " "} />
          <SwitchTransition mode="out-in">
            <CSSTransition
              key={currentStepData.data}
              addEndListener={(node, done) => {
                node.addEventListener("transitionend", done, false);
              }}
              classNames="n-fade"
            >
              <div className="t-flex t-flex-col t-m-auto t-w-full xs:t-w-max">
                {
                  currentStepData.data && (
                    <Fragment>
                      {
                        currentStepData.data.map(option => (
                          <InputBox
                            key={option.field_name}
                            placeholder={option.placeholder}
                            error={error && error[option.field_name]}
                            value={currentData[option.field_name]}
                            onChange={(e) => {
                              updateData(prevData => Object.assign({}, prevData, { [option.field_name]: e.target.value }))
                            }}
                          />
                        ))
                      }
                      <SelectionButton maxWidth loading={loading} selected type="submit" text="Next" />
                    </Fragment>
                  )
                }
              </div>
            </CSSTransition>
          </SwitchTransition>
        </Fragment>
      );
    case 'text':
      return (
        <Fragment>
          <div className="t-flex t-flex-col">
            <p className={`t-text-${color.base} t-font-bold t-text-center t-text-lg t--mt-6 xs:t--mt-24 md:t--mt-6 t-mb-8 md:t-mb-6`}>
              Here&apos;s what to expect
                            </p>
            <FinalStepNotes />
            <div className="t-flex-auto t-text-center t-mt-5 t-mb-8 md:t-mb-12">
              <SelectionButton maxWidth text="Okay, got it" onClick={e => {
                e.preventDefault();
                toggle();
              }}/>
            </div>
            <p className={'t-text-center t-text-sm t-mb-6'}>
              This is a solicitation for insurance. A licensed insurance agent/producer may contact you.
            </p>
          </div>
        </Fragment>
      )
    case 'coupon': {
      const { coupon_value, coupon_code, redirect_url } = currentStepData.data[0];
      return (
        <Fragment>
          <div className="t-flex t-flex-col t-items-center t--mt-17 xs:t--mt-40 md:t--mt-19">
            <CouponStepNotes
              couponValue={coupon_value}
              couponCode={coupon_code}
              redirectUrl={redirect_url}
            />
          </div>
        </Fragment>
      )
    }
    case 'map_searching':
    case 'map_search_done':
      return (
        <Fragment>
          <div className="t-flex t-flex-col t-items-center t-mt-16">
            <Question text={currentStepData.question || " "} />
            <SwitchTransition mode="out-in">
              <CSSTransition
                key={currentStepData.type}
                addEndListener={(node, done) => {
                  node.addEventListener("transitionend", done, false);
                }}
                classNames="n-fade-plain"
              >
                <div style={{ width: '168px', height: '100px' }} className="t-mt-8 t-mb-12 xs:t-mb-24">
                  <img src={currentStepData.data} className="t-w-full t-h-auto" />
                </div>
              </CSSTransition>
            </SwitchTransition>
            <div className="t-p-5 t-text-center t-pt-7 t-pb-7 t-bg-yellow-150 t-ml-auto t-mr-auto t-w-full xs:t-max-w-md2 ">
              <p className={`t-text-${color.base} t-font-bold t-uppercase t-text-xl t-mb-2`}>
                { currentStepData.title }
              </p>
              <Header text={currentStepData.description} noMargin />
            </div>
          </div>
        </Fragment>
      )
    default:
      return null;
  }
}

const InvertedArea = ({currentStepData, invertedAreaHeader}) => {
  let containerDivClass = '';
  if (currentStepData.step_key == 'zip_code') {
    containerDivClass = 'chat-box-zipcode';
  } else if (currentStepData.step_key == 'complete') {
    containerDivClass = 'chat-box-complete'
  } else if (currentStepData.step_key == 'coupon') {
    containerDivClass = 'chat-box-coupon';
  }
  return (
    <SwitchTransition mode="out-in">
      <CSSTransition
        key={currentStepData.question || 'noQuestion'}
        addEndListener={(node, done) => {
          node.addEventListener("transitionend", done, false);
        }}
        classNames="n-fade-height"
      >
        <div className={`${containerDivClass}`}>
          {
            (
              currentStepData.step_key == 'zip_code' &&
              currentStepData.type != 'map_searching' &&
              currentStepData.type != 'map_search_done'
            ) ? (
                <div style={{ backgroundImage: 'linear-gradient(288deg, #ec5749, #fc8d77 100%)' }} className="md:t-rounded-t t-relative t-w-full t-h-full">
                  <div className="t-flex t-flex-col t-justify-center t-pt-5 t-pb-5 xs:t-pt-8 xs:t-pb-8 t-h-full t-pl-5 t-pr-20 xs:t-pr-5" style={{ margin: '0 auto', width: 'min(100%, 520px)' }}>
                    <Question mobileLeftAlign reduceMargin noPadding text='Just a couple more questions' inverted />
                    <Header mobileLeftAlign text={invertedAreaHeader} inverted />
                    <img src={SuccessLeft} className="t-hidden xs:t-flex t-absolute t-left-0 t-bottom-0" />
                    <img src={SuccessRight} className="t-absolute t-right-0 t-bottom-0" />
                  </div>
                </div>
              ) : null
          }
          {
            currentStepData.step_key == 'complete' ? (
              <div style={{ backgroundImage: 'linear-gradient(288deg, #ec5749, #fc8d77 100%)' }} className="md:t-rounded-t t-relative t-w-full t-h-full md:t-pt-5 md:t-pb-8">
                <div className="t-flex t-flex-col t-h-full t-pb-8 md:t-pb-0 t-pl-5 t-pr-5" style={{ margin: '0 auto', width: 'min(100%, 520px)' }}>
                  <img src={Envelope} className="t-mt-8 md:t--mt-19" />
                  <Question noPadding reduceMargin text={currentStepData.question} inverted />
                  <Header text={currentStepData.title} inverted />
                </div>
              </div>
            ) : null
          }
          {
            currentStepData.step_key == 'coupon' ? (
              <div style={{ backgroundImage: 'linear-gradient(288deg, #ec5749, #fc8d77 100%)' }} className="md:t-rounded-t t-relative t-w-full t-h-full">
                <div className="t-flex t-pl-5 t-pr-5 t-pt-8 t-pb-8 t-flex-col t-items-center t-justify-center t-h-full" style={{ margin: '0 auto', width: 'min(100%, 520px)' }}>
                  <p className="t-text-md xs:t-text-xl t-text-white t-font-bold t-m-0">
                    Unfortunately you do not qualify
                            </p>
                </div>
              </div>
            ) : <Fragment />
          }
        </div>
      </CSSTransition>
    </SwitchTransition>
  )
}

const useValidation = (apiUrl, chatbotKey) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const validate = async (step_key, value, firstLoad = false) => {
    try {
      setLoading(true);
      const res = await axios.post(apiUrl, {
        step_key: step_key,
        data: value,
        uuid: Utility.getCookie('mid'),
        chatbot_key: chatbotKey,
        chatbot_type: 'annuity'
      });
      if (res.data) {
        const { success, errors, next_step } = res.data;
        if (success) {
          if (firstLoad) {
            setLoading(false);
          }
          setError(null)
          return next_step;
        } else {
          setLoading(false);
          setError(errors);
          return false;
        }
      }
    } catch(e) {
      setLoading(false);
      return false;
    }
  }

  return {
    setLoading,
    loading,
    error,
    validate
  }
}

const useSteps = () => {
  const currentLocalStep = getFromSession('annuity_step');
  const totalLocalStep = getFromSession('annuity_total_step');
  const [currentStep, setCurrentStep] = useState(parseInt(currentLocalStep || -1));
  const [totalSteps, setTotalSteps] = useState(parseInt(totalLocalStep || -1));
  const hasPrevStep = currentStep !== 0;
  const hasNextStep = currentStep !== totalSteps - 1;

  useEffect(() => {
    saveToSession('annuity_step', currentStep);
  }, [currentStep])

  useEffect(() => {
    saveToSession('annuity_total_step', totalSteps);
  }, [totalSteps])

  const nextStep = useCallback(
    () => {
      if (hasNextStep) {
        setCurrentStep(prevStep => prevStep + 1)
        return true;
      } else {
        return false;
      }
    },
    [currentStep]
  );

  const prevStep = useCallback(
    () => {
      if (hasPrevStep) {
        setCurrentStep(prevStep => prevStep - 1)
        return true;
      } else {
        return false;
      }
    },
    [currentStep]
  );

  return {
    currentStep,
    nextStep,
    prevStep,
    hasPrevStep,
    hasNextStep,
    setTotalSteps,
    totalSteps,
    setCurrentStep
  }
}

const useStepData = (currentStep) => {
  const [defaultStepData, setCurrentStepData] = useState({ type: 'input' });
  const [currentLoadingData, setLoadingData] = useState(false);
  const [data, setStepData] = useState(JSON.parse(getFromSession('annuity_step_data') || '[]'));

  const currentStepData = currentLoadingData || defaultStepData;

  useEffect(() => {
    if (data.length > 0 && currentStep >= 0) {
      if (data[currentStep]) {
        setCurrentStepData(data[currentStep]);
      } else {
        const storageData = getFromSession('annuity_step_data');
        if (storageData) {
          setCurrentStepData(JSON.parse(storageData)[currentStep])
        }
      }
    }
  }, [currentStep, data])

  useEffect(() => {
    saveToSession('annuity_step_data', JSON.stringify(data))
  }, [data])

  useEffect(() => {
    if (!forceShow) {
      if (currentStepData.step_key == 'complete') {
        Utility.setLocalCookies('annuity_complete', true);
      }
      if (currentStepData.step_key == 'coupon') {
        const sixMonth = new Date();
        sixMonth.setTime(sixMonth.getTime() + (6 * 30 * 24 * 60 * 60 * 1000));
        Utility.setCookieWithExpiration('annuity_complete', true, sixMonth.toGMTString());
        Utility.setCookieWithExpiration('annuity_not_qualified', true, sixMonth.toGMTString());
      }
    }
  }, [currentStepData])

  const addStepData = stepData => {
    if (!JSON.stringify(data).includes(JSON.stringify(stepData))) {
      setStepData(prevData => ([...prevData, stepData]));
    }
  }

  return {
    currentStepData,
    setStepData,
    addStepData,
    setLoadingData,
    stepData: data
  }
}

const useCollapse = () => {
  const [show, setShow] = useState(false);
  const toggle = useCallback((assignedState = null) => {
    if (assignedState != null) {
      setShow(assignedState);
    } else {
      setShow(prevShow => !prevShow)
    }
  }, [show]);

  return {
    showCollapse: show,
    toggleCollapse: toggle
  }
}

const AnnuityChatbot = ({ chatBotConfig, premium }) => {
  const apiUrls = {
    step: chatBotConfig.apiUrlsStep,
    start: chatBotConfig.apiUrlsStart,
    show: chatBotConfig.apiUrlsShow,
  }
  const { chatbotKey, chatbotTitle, chatbotContent, invertedAreaHeader, additionalNote } = chatBotConfig;
  const { show, toggle } = useModal();
  const [ seen, setSeen ] = useState(false);
  const { currentStep, prevStep, hasPrevStep, setTotalSteps, totalSteps, setCurrentStep } = useSteps();
  const { currentStepData, addStepData, setStepData, stepData, setLoadingData } = useStepData(currentStep, premium);
  const { validate, loading, setLoading, error } = useValidation(apiUrls.step, chatbotKey);
  const [currentData, updateData] = useState({});
  const containerRef = useRef(null);
  const setContainerRef = useCallback(node => {
    if (node !== null) {
      containerRef.current = node;
    }
  }, [show]);
  const [initialLoad, setInitialLoad] = useState(true);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await validate(currentStepData.step_key, currentData);
    if (result) {
      saveToSession(currentStepData.step_key, JSON.stringify(currentData));
      updateData({});
      if (currentStepData.step_key == 'zip_code') {
        setLoadingData({
          step_key: 'zip_code',
          type: 'map_searching',
          question: 'Searching in your area...',
          title: 'Did you know?',
          description: 'Market volatility and low-interest rates provides the perfect environment for a retirement safety product like fixed index annuities.',
          data: MapAnimation
        });
        setLoading(false);
        setTimeout(() => {
          setLoadingData({
            step_key: 'zip_code',
            type: 'map_search_done',
            question: 'Searching in your area...',
            title: 'Did you know?',
            description: 'Market volatility and low-interest rates provides the perfect environment for a retirement safety product like fixed index annuities.',
            data: MapSuccess
          })
          setTimeout(() => {
            const { progress, ...rest } = result;
            const { total, current } = progress;
            if (total == 0 && current == 0) {
              setStepData([rest])
            } else {
              if (!stepData[current]) {
                addStepData(rest);
              }
            }
            setTotalSteps(total);
            setCurrentStep(current);
          }, 1150);
          setTimeout(() => {
            setLoadingData(false);
          }, 1500)
        }, 4000)
      } else {
        const { progress, ...rest } = result;
        const { total, current } = progress;
        // save current step data into cookie
        if (total == 0 && current == 0) {
          setStepData([rest])
        } else {
          if (!stepData[current]) {
            addStepData(rest);
          }
        }
        setTotalSteps(total);
        // get current step data from cookie if exists
        setCurrentStep(current);
        setLoadingData(false);
        setLoading(false);
      }
    }
  };

  // Initial data fetch for step data
  useEffect(async () => {
    try {
      if (!seen && forceShow) {
        toggle(true);
      }
      if (initialLoad) {
        setInitialLoad(false);
        const result = await validate(null, null, true);
        if (result) {
          const { progress, ...rest } = result;
          const { total, current } = progress;
          addStepData(rest);
          const localStep = getFromSession('annuity_step');
          const totalLocalStep = getFromSession('annuity_total_step');
          if (localStep && parseInt(localStep) != -1) {
            setCurrentStep(parseInt(localStep));
          } else {
            setCurrentStep(current);
          }
          if (totalLocalStep && parseInt(totalLocalStep) != -1) {
            setTotalSteps(parseInt(totalLocalStep))
          } else {
            setTotalSteps(total);
          }
        }
      }
      if (show) {
        setSeen(true);
        // prevent background scrolling
        document.body.style.top = `-${window.scrollY}px`;
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
      } else {
        // reset body styling for background scrolling purposes
        const scrollY = document.body.style.top;
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        window.scrollTo(0, parseInt(scrollY || -window.scrollY) * -1);
      }
    } catch (e) { }
  }, [show])

  useEffect(() => {
    const sessionStepData = getFromSession(currentStepData.step_key);
    if (sessionStepData) {
      updateData(JSON.parse(sessionStepData));
    }
  }, [currentStepData])

  const completedSurvey = forceShow ? 'unknown' : Utility.getCookie('annuity_complete', true);

  return (
    <Fragment>
      <SwitchTransition mode="out-in">
        <CSSTransition
          key={show}
          addEndListener={(node, done) => {
            node.addEventListener("transitionend", done, false);
          }}
          classNames="n-fade"
        >
          { show ? (
            <Container complete={currentStepData.step_key == 'complete'} containerRef={setContainerRef} toggle={toggle}>
              {
                (
                  totalSteps !== 0 && currentStepData.step_key != 'zip_code') && (<ProgressBar currentStep={currentStep} totalSteps={totalSteps} />)
              }
              <InvertedArea currentStepData={currentStepData} invertedAreaHeader={invertedAreaHeader} />
              <div className="md:t-rounded-b t-transition-all t-will-change-height t-transition-linear t-bg-white" style={{
                height: 'calc(100%)'
              }}>
                <form onSubmit={handleSubmit}>
                  {
                    hasPrevStep && (
                      <a
                        href="#"
                        onClick={e => {
                          e.preventDefault();
                          prevStep();
                        }}
                        className={`t-absolute t-font-bold t-text-${color.base} hover:t-text-${color.hover} t-ml-1 t-left-4 t-top-4 md:t-left-8 md:t-top-8 t-text-base`}
                      >
                        <span className="fa fa-angle-left t-font-bold" />
                        {" Back"}
                      </a>
                    )
                  }
                  <SwitchTransition mode="out-in">
                    <CSSTransition
                      key={currentStepData.title || 'noTitle'}
                      addEndListener={(node, done) => {
                        node.addEventListener("transitionend", done, false);
                      }}
                      classNames="n-fade"
                    >
                      <div className="t-pl-5 t-pr-5 t-ml-auto t-mr-auto t-mt-17 md:t-mt-19 xs:t-mt-40" style={{width: 'min(100%, 520px)'}}>
                        {renderBody(currentStepData, loading, error, currentData, updateData, toggle, containerRef) }
                      </div>
                    </CSSTransition>
                  </SwitchTransition>
                  <AdditionalNotes currentStepData={currentStepData} totalSteps={totalSteps} additionalNote={additionalNote} />
                  <IllustrationBox currentStepData={currentStepData} totalSteps={totalSteps} />
                </form>
              </div>
            </Container>
          ) : completedSurvey == 'unknown' ? (
              <ChatbotAnchor toggle={toggle} apiUrls={apiUrls} premium={premium} chatbotTitle={chatbotTitle} chatbotContent={chatbotContent} chatbotKey={chatbotKey} />
          ) : <Fragment />
        }
        </CSSTransition>
      </SwitchTransition>
    </Fragment>
  )
}

const ChatbotAnchor = ({ toggle, apiUrls, premium, chatbotTitle, chatbotContent, chatbotKey }) => {
  const [showChatbot, toggleChatbot] = useState(false);
  const { show, toggle: toggleChatbotAnchor } = useModal();

  useEffect(async () => {
    try {
      await axios.post(apiUrls.show, { chatbot_type: 'annuity' })
      const currentSession = getFromSession('Annuity LeadsNextStep-01-lets-begin');
      if (!currentSession) {
        await axios.post(apiUrls.start, { uuid: Utility.getCookie('mid'), chatbot_key: chatbotKey, force_show: forceShow })
        if (forceShow) {
          saveToSession('Annuity LeadsNextStep-01-lets-begin', true)
        }
      }
      toggleChatbot(true);

      const investorType = Utility.getCookie('invstr_seg');
      if (investorType == 'unknown' || investorType == 'investor') {
        toggleChatbotAnchor(true);
      }
      // const shown = Utility.getCookie('annuity_daily_shown');
      // if investor type is individual or unknown
      // and chatbot has not been shown today
      // if ((investorType == 'unknown' || investorType == 'investor') && (shown == 'unknown')) {
      //   const shownInAMonth = Utility.getCookie('annuity_monthly_shown');
      //   if (shownInAMonth == 'unknown') {
      //     // Chatbot have not been shown this month
      //     let oneDay = new Date();
      //     oneDay.setTime(oneDay.getTime() + (1 * 24 * 60 * 60 * 1000));
      //     Utility.setCookieWithExpiration('annuity_daily_shown', true, oneDay.toGMTString());

      //     let thirtyDays = new Date();
      //     thirtyDays.setTime(thirtyDays.getTime() + (30 * 24 * 60 * 60 * 1000));
      //     Utility.setCookieWithExpiration('annuity_monthly_shown', "1--" + thirtyDays.toGMTString(), thirtyDays.toGMTString());
      //     toggleChatbotAnchor(true);
      //   } else {
      //     // Chatbot have been shown this month
      //     const [amountViewed, expirationDate] = shownInAMonth.split('--');
      //     const amountViewedInInt = parseInt(amountViewed);
      //     if (amountViewedInInt < 3) {
      //       // Chatbot have not been shown more than 3 times
      //       Utility.setCookieWithExpiration('annuity_monthly_shown', `${amountViewedInInt + 1}--${expirationDate}`, expirationDate)
      //       let oneDay = new Date();
      //       oneDay.setTime(oneDay.getTime() + (1 * 24 * 60 * 60 * 1000));
      //       Utility.setCookieWithExpiration('annuity_daily_shown', true, oneDay.toGMTString());
      //       toggleChatbotAnchor(true);
      //     }
      //   }
      // }
    } catch(e) {}
  }, []);

  return (
    <SwitchTransition mode="out-in">
      <CSSTransition
        key={showChatbot}
        addEndListener={(node, done) => {
          node.addEventListener("transitionend", done, false);
        }}
        classNames="n-fade"
      >
      {
        showChatbot ? (
          <Fragment>
            <SwitchTransition mode="out-in">
              <CSSTransition
                key={show}
                addEndListener={(node, done) => {
                  node.addEventListener("transitionend", done, false);
                }}
                classNames="n-fade"
              >
                {
                  show ? (
                    <div className="t-fixed t-right-4 t-w-89 t-rounded-lg xs:t-right-10 t-bottom-28 xs:t-bottom-32 t-flex t-flex-col t-z-2000 t-bg-white t-shadow-strong">
                      <div className={`t-flex t-bg-${color.base} t-pl-5 t-py-1 xs:t-pt-3 xs:t-pb-3 t-rounded-t-lg`}>
                        <img
                          width="50"
                          height="50"
                          className="t-mr-3"
                          src={Avatar1x}
                          srcSet={`${Avatar2x} 2x,${Avatar3x} 3x`}
                        />
                        <div className="t-flex t-flex-col t-text-white t-justify-center">
                          <p className="t-text-base t-font-bold t-mb-0">
                            Ashley
                          </p>
                          <p className="t-text-sm t-mb-0">
                            Annuity partner
                          </p>
                        </div>
                      </div>
                      <div className="t-py-4 t-px-5 t-text-left t-flex t-flex-col t-text-white" style={{backgroundImage: 'linear-gradient(306deg, rgb(255, 140, 103), rgb(255, 104, 101) 100%)'}}>
                        <p className="t-mb-2 t-text-base t-font-semibold">
                          Did you know?
                        </p>
                        <p className="t-mb-2 t-text-md t-font-bold">
                          {chatbotTitle}
                        </p>
                        <p className="t-mb-0 t-text-base">
                          The other half just doesn&apos;t know about them yet.
                        </p>
                      </div>
                      <div className="t-px-5 t-py-4 t-text-center t-flex t-flex-col t-items-center">
                        <p className="t-text-base t-mb-4 t-font-bold">
                          {chatbotContent}
                        </p>
                        <SelectionButton fixedWidth={220} text="Sure, let's begin" onClick={() => {
                            toggle(true)
                          }}
                        />
                        <a href="#" className="t-mt-4 t-text-base t-font-bold" onClick={e => {
                          e.preventDefault();
                          toggleChatbotAnchor();
                          if (!forceShow) {
                            if (!premium) {
                              let thirtyDays = new Date();
                              thirtyDays.setTime(thirtyDays.getTime() + (30 * 24 * 60 * 60 * 1000));
                              Utility.setCookieWithExpiration('annuity_closed', true, thirtyDays.toGMTString());
                            } else {
                              let threeMonths = new Date();
                              threeMonths.setTime(threeMonths.getTime() + (3 * 30 * 24 * 60 * 60 * 1000));
                              Utility.setCookieWithExpiration('annuity_closed', true, threeMonths.toGMTString())
                            }
                          }
                        }}>
                          No thanks
                        </a>
                      </div>
                    </div>
                  ) : <Fragment />
                }
              </CSSTransition>
            </SwitchTransition>
            <button
              onClick={() => {
                const currentSession = getFromSession('Annuity LeadsNextStep-01-lets-begin');
                if (currentSession) {
                  toggle(true);
                } else {
                  if (!show) {
                    toggleChatbotAnchor()
                  }
                }
              }}
              className="t-fixed t-z-1500 t-right-10 t-bottom-8"
            >
              <img className="t-w-17 xs:t-w-20" src={show ? ChatbotOpenIcon : ChatbotIcon} />
            </button>
          </Fragment>
        ) : <Fragment />
      }
    </CSSTransition>
    </SwitchTransition>
  )
}

export { Header, Container, ProgressBar };
export default AnnuityChatbot;
